// extracted by mini-css-extract-plugin
export default {"bodyBackground":"cartDocDetailModalFrame_bodyBackground__ura7a","modalContainer":"cartDocDetailModalFrame_modalContainer__vZ2-A","modal":"cartDocDetailModalFrame_modal__gPU2s"};